export default function nFormatter(number, digits) {
  if (number < 1000) {
    return number.toString();
  } else {
    return (number / 1000).toFixed(digits) + 'k';
  }
}
flarum.reg.add('ziiven-ziven-core', 'common/helpers/nFormatter', nFormatter);